// extracted by mini-css-extract-plugin
export var container = "landing-module--container--80e54";
export var featureItem = "landing-module--featureItem--0f621";
export var prototypingServiceSection = "landing-module--prototypingServiceSection--2c43d";
export var sectionDescription = "landing-module--sectionDescription--10c31";
export var serviceFeatures = "landing-module--serviceFeatures--c4623";